import { render, staticRenderFns } from "./DesignBaseAlert.vue?vue&type=template&id=88d9a194&"
import script from "./DesignBaseAlert.vue?vue&type=script&lang=js&"
export * from "./DesignBaseAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports